export default __webpack_public_path__ + "static/media/download_disabled.d7a27dc4.png";